// extracted by mini-css-extract-plugin
export var LastArrow = "tabs-module--LastArrow--0ba80";
export var accordion = "tabs-module--accordion--5251c";
export var accordionContainer = "tabs-module--accordionContainer--48d6a";
export var accordionContent = "tabs-module--accordionContent--0f4ca";
export var accordionTitle = "tabs-module--accordionTitle--09b63";
export var active = "tabs-module--active--70a4b";
export var basicTabSection = "tabs-module--basicTabSection--19dd8";
export var buttonWrapper = "tabs-module--button--wrapper--91280";
export var container = "tabs-module--container--5c0fc";
export var contentStyles = "tabs-module--contentStyles--6c227";
export var current = "tabs-module--current--8f8b1";
export var disabled = "tabs-module--disabled--509d1";
export var footerText = "tabs-module--footerText--72851";
export var headerText = "tabs-module--headerText--83927";
export var insideContent = "tabs-module--inside-content--381f7";
export var left = "tabs-module--left--447f6";
export var mobileYear = "tabs-module--mobileYear--83aa7";
export var nextPrevWrapper = "tabs-module--nextPrevWrapper--bb67f";
export var nextText = "tabs-module--nextText--24204";
export var prevText = "tabs-module--prevText--893d5";
export var right = "tabs-module--right--d9058";
export var rotate_down = "tabs-module--rotate_down--9c317";
export var rotate_up = "tabs-module--rotate_up--d2389";
export var smallContainer = "tabs-module--smallContainer--5da31";
export var tab = "tabs-module--tab--b4cba";
export var tabContainer = "tabs-module--tabContainer--c906a";
export var tabContentWrap = "tabs-module--tab-content-wrap--255fb";
export var tabList = "tabs-module--tabList--b2306";
export var tabcontent = "tabs-module--tabcontent--55edb";
export var tablink = "tabs-module--tablink--f9045";
export var tabsDropdownList = "tabs-module--tabsDropdownList--9d4b7";
export var tabsLinkWrapper = "tabs-module--tabsLinkWrapper--1a793";
export var timelineTabSection = "tabs-module--timelineTabSection--bb435";
export var timeline_footer_text = "tabs-module--timeline_footer_text--3ddda";
export var yearContent = "tabs-module--year-content--22e82";
export var yearLinks = "tabs-module--yearLinks--adf5d";